import React from 'react';
import { ThemeContext } from '../../ContextProvider/ThemeContext';
// import WindowSize from '../../Utils/WindowSize';
import styles from './About.module.css';

const About = () => {
	const { newTheme } = React.useContext(ThemeContext);
	// const [width] = WindowSize();
	// const img =
	// 	width < 650
	// 		? 'https://avatars.githubusercontent.com/u/86410121?v=4' // my Picture
	// 		: 'https://github.com/himrd95/portfolio/blob/main/public/developer.gif?raw=true';
	return (
		<div
			className={styles.container}
			style={{ boxShadow: `3px 3px 5px ${newTheme.line}` }}
		>
			<div className={styles.first}>
				<img src={"https://github.com/himrd95/portfolio/blob/main/public/developer.gif?raw=true"} alt='' />
			</div>
			<div className={styles.second}>
				<h1
					style={{ color: `${newTheme.title}` }}
					className={styles.heading}
				>
					About Me
				</h1>
				<div className={styles.borderBottom} />
				<p
					style={{ color: `${newTheme.para}` }}
					className={styles.aboutMe}
				>
					Hello! My name is Nitesh, and I am passionate about crafting digital experiences on the web. My journey into web development began several years ago when I embarked on the journey of manipulating and refining web content. This initial foray into HTML and CSS ignited my curiosity and laid the foundation for my career in web development. <br />
					<br /> Over the years, I have accumulated over 4 years of experience, specializing in Node.js and AWS, along with the MERN stack. I have developed numerous web applications and contributed to significant projects. Along the way, I have not only deepened my technical proficiency but also gained valuable insights into teamwork, leadership, and effective communication, here I am
					<span style={{ color: `#00a0a0` }}>
						{' '}
						looking for an opportunity as a full stack web developer
					</span>
					.
				</p>
			</div>
		</div>
	);
};

export default About;
